/* eslint-disable jsx-a11y/anchor-is-valid */
import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { GamePlayListing } from "../../modules/gamePlay/component/GamePlayListing";

const GamePlayContext = createContext();

const GamePlayWrapper = ({ isDemo }) => {
  const value = {};

  return (
    <GamePlayContext.Provider value={value}>
      <Routes>
        <Route
          path="/:companyCode/:gameCode/:companyOffset/:scrollPosition/:gameType/:searchName"
          element={<GamePlayListing isDemo={isDemo} />}
        />
        <Route
          path="/:companyCode/:gameCode/:companyOffset/:scrollPosition/:gameType"
          element={<GamePlayListing isDemo={isDemo} />}
        />
      </Routes>
    </GamePlayContext.Provider>
  );
};

export { GamePlayWrapper };
